"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AuthState = _interopRequireDefault(require("../../AuthState"));

var _callEach = _interopRequireDefault(require("../../utilities/callEach"));

var _emcm = require("./api/emcm");

var _estore = require("../api/estore");

var _openHiddenIframe = _interopRequireDefault(require("./utilities/openHiddenIframe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaultState = {
  authState: _AuthState["default"].UNKNOWN,
  itemsInCart: 0,
  userName: null,
  userFirstName: null
};

var EMCMLoginService = /*#__PURE__*/function () {
  function EMCMLoginService(config) {
    _classCallCheck(this, EMCMLoginService);

    this.onChangeCallbacks = [];
    this.state = _objectSpread({}, defaultState);
    this.config = config;
  }
  /**
   * Login with JWT. Send a request to EMCM, using valid JWT from ID Service,
   * providing a transferToken to then login to legacy Tax site and eStore if
   * federate is true.
   */


  _createClass(EMCMLoginService, [{
    key: "loginWithJWT",
    value: function () {
      var _loginWithJWT = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(jwt, federate) {
        var userLoginResponse, transferToken, promises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _emcm.userlogin)(this.config.emcm.location, this.config.emcm.cors, jwt);

              case 2:
                userLoginResponse = _context.sent;
                transferToken = userLoginResponse.transferToken;

                if (!federate) {
                  _context.next = 7;
                  break;
                }

                promises = this.config.transferIframeLocations.map(function (url) {
                  return (0, _openHiddenIframe["default"])("".concat(url).concat(transferToken));
                });
                return _context.abrupt("return", Promise.all(promises));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginWithJWT(_x, _x2) {
        return _loginWithJWT.apply(this, arguments);
      }

      return loginWithJWT;
    }()
    /**
     * Redirect to OnePass with the provided transfer token.
     */

  }, {
    key: "loginWithTransferToken",
    value: function loginWithTransferToken(transferToken) {
      var transferUrl = this.config.onepass.transferUrl;
      var transferTokenParam = "transferToken=".concat(encodeURIComponent(transferToken));
      window.location.replace("".concat(transferUrl).concat(transferUrl.includes("?") ? "&" : "?").concat(transferTokenParam));
    }
    /**
     * Pop the redirect URL from session storage, if one was set. `null` otherwise.
     */

  }, {
    key: "popLoginRedirectURL",
    value: function popLoginRedirectURL() {
      var redirectUrl = sessionStorage.getItem(this.config.redirectUrlSessionKey);

      if (!redirectUrl) {
        return null;
      }

      sessionStorage.removeItem(this.config.redirectUrlSessionKey);
      return redirectUrl;
    }
    /**
     * EMCM Log out. Send a request to EMCM, and when it completes, reset this
     * instance to its default state and trigger a change.
     */

  }, {
    key: "emcmLogout",
    value: function () {
      var _emcmLogout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _emcm.userlogout)(this.config.emcm.location, this.config.emcm.cors);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function emcmLogout() {
        return _emcmLogout.apply(this, arguments);
      }

      return emcmLogout;
    }()
    /**
     * Initialize the object. Make calls to servers, and update the state based on responses.
     */

  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchUserDetails();

              case 2:
                if (!(this.state.authState === _AuthState["default"].LOGGED_IN)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.fetchCartDetails();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function activate() {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
    /**
     * Fetch user details. Send a request to EMCM, to retrieve user details from
     * httpOnly cookie.
     */

  }, {
    key: "fetchUserDetails",
    value: function () {
      var _fetchUserDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userDetails;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return (0, _emcm.getuserdetails)(this.config.emcm.location, this.config.emcm.cors);

              case 3:
                userDetails = _context4.sent;

                if (userDetails.loggedIn) {
                  this.state.authState = _AuthState["default"].LOGGED_IN;
                  this.state.userName = userDetails.userName;
                  this.state.userFirstName = userDetails.firstName;
                } else {
                  this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                    authState: _AuthState["default"].LOGGED_OUT
                  });
                }

                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                  authState: _AuthState["default"].LOGGED_OUT
                });
                throw _context4.t0;

              case 11:
                _context4.prev = 11;
                this.privateTriggerChange();
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 11, 14]]);
      }));

      function fetchUserDetails() {
        return _fetchUserDetails.apply(this, arguments);
      }

      return fetchUserDetails;
    }()
    /**
     * Fetch cart details. Send a request to eStore, to retrieve current shopping
     * cart item count.
     */

  }, {
    key: "fetchCartDetails",
    value: function () {
      var _fetchCartDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var cartDetails;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _estore.cart)(this.config.estore.location);

              case 2:
                cartDetails = _context5.sent;
                this.state.itemsInCart = cartDetails.itemsInCart;
                this.privateTriggerChange();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchCartDetails() {
        return _fetchCartDetails.apply(this, arguments);
      }

      return fetchCartDetails;
    }()
    /**
     * Trigger the login procedure. Likely, redirect to a OnePass login screen.
     */

  }, {
    key: "login",
    value: function login() {
      sessionStorage.setItem(this.config.redirectUrlSessionKey, window.location.href);
      window.location.replace(this.config.identityService.loginUrl);
    }
    /**
     * Logout. Call federatedLogout and logout of Hybris and Wordpress sites also.
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var promises;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.emcmLogout();

              case 2:
                promises = this.config.signoutIframeLocations.map(function (url) {
                  return (0, _openHiddenIframe["default"])(url);
                });
                _context6.next = 5;
                return Promise.all(promises);

              case 5:
                this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                  authState: _AuthState["default"].LOGGED_OUT
                });
                this.privateTriggerChange();

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      (0, _callEach["default"])(this.onChangeCallbacks, this);
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.config.site.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.state.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.config.estore.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.state.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.config.emcm.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.config.emcm.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.state.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.state.userFirstName;
    }
  }]);

  return EMCMLoginService;
}();

exports["default"] = EMCMLoginService;